import { useContext } from '@fipnooone/react-modal';
import { FC, ReactNode } from 'react';

import { Icon } from '@/Components/UI/Icon';

interface InfoProps {
    children?: ReactNode;
}

export const ModalInfo: FC<InfoProps> = ({ children }) => {
    const modal = useContext();

    return (
        <div className="info">
            <Icon name="close" size={20} onClick={() => modal.close()} />

            {children}
        </div>
    );
};
